import React from 'react'

export default function Introduction() {
    return (
            <div>
                <section id="home" className="js-fullheight" data-section="home">
                    <div className="flexslider js-fullheight">
                        <ul className="slides">
                            <li style={{ backgroundImage: 'url(images/ed3.JPG)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner js-fullheight">
                                                <div className="desc">
                                                    <h1>Hi!<br />I'm Ed </h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://drive.google.com/file/d/1HYwAAxtKG1oADzkwwnIOyB3uWhKAoJuu/view?usp=sharing" target="_blank" rel="noopener noreferrer">View my Resume<i className="icon-download4" /></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li style={{ backgroundImage: 'url(images/ed.JPG)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner">
                                                <div className="desc">
                                                    <h1>Sr Technical Program Manager<br />AI-Driven Delivery &amp; Transformation</h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://github.com/edward0rtiz" target="_blank" rel="noopener noreferrer">View Projects <i className="icon-briefcase3" /></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li style={{ backgroundImage: 'url(images/ed2.jpg)' }}>
                                <div className="overlay" />
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                                            <div className="slider-text-inner">
                                                <div className="desc">
                                                    <h1>Want to know more? <br />read my posts... </h1>
                                                    <p><a className="btn btn-primary btn-learn" href="https://medium.com/@edward0rtiz" target="_blank" rel="noopener noreferrer">View publications <i className="icon-book" /></a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>
            </div>
        );
}